<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div>

  <vs-alert icon="warning" active="true" color="warning" class="my-5" v-show="showWarning">
    <span style="display: inline-block;margin-top:10px!important;">{{ $t('ROLES.pending_text_alert') }}</span> <div style="float: right!important;"><vs-button color="danger" @click="cancelChanges" type="border" icon-pack="feather" icon="icon-x">Cancelar</vs-button></div>
  </vs-alert>

  <vs-prompt
    :accept-text="`${$t('ROLES.migrate')}`"
    :cancel-text="`${$t('ROLES.cancel')}`"
    @accept="migrateRoleUsers"
    @close="closeMigratePrompt"
    :title="`${$t('ROLES.migrate')} ${$t('ROLES.users')}`"
    :is-valid="validMigrateForm"
    :active.sync="activeMigratePrompt">
    <div class="con-exemple-prompt">
      <span>Selecione o cargo</span>
      <v-select v-model="roleToMigrate" label="name" autocomplete="off" :options="roleOptionsFiltered" name="roles" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
    </div>
  </vs-prompt>

  <vx-card :title="`${$t('ROLES.roles')}`" save-layout add-new @addNewClicked="addNewClicked" @saveLayoutClicked="updateLayout" @click="clickCard($event)">
    <v-tree ref='tree' :canDeleteRoot="false" :data='treeData' :draggable='true' :tpl='tpl' :halfcheck='false' :multiple="false" @drag-node-end="endDrag"/>
  </vx-card>

</div>

</template>

<script>

// import vSelect from 'vue-select'
import VxCard from '../../../components/vx-card/VxCard.vue'
import { VTree, VSelectTree}  from 'vue-tree-halower'
import { performFetch } from '../../../helpers'

import vSelect from 'vue-select'
// import { VoEdit } from 'vue-orgchart'
// import 'vue-orgchart/dist/style.min.css'

export default {
  components: {
    vSelect,
    VxCard,
    VTree,
    VSelectTree
  },
  data () {
    return {
      chartData: null,
      showBody: false,
      newChartData: [],
      tempRolesList: [],
      showWarning: false,
      currentRoleToDelete: '',
      activeMigratePrompt: false,
      roleToMigrate: null,
      roleOptions: [],
      roleOptionsFiltered: [],
      treeDataNew: [],
      treeData: [{
        expanded: true,
        title: 'CEO',
      }],
      treeDataOld: []
    }
  },
  computed: {
    validMigrateForm () {
      if (this.roleToMigrate) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {

    document.title = `${document.title.split(' | ')[0]  } | Cargos`

  },
  created () {

    this.getParameters()

    this.$vs.loading({type: 'default'})
    this.loadLayout()
  },
  methods: {
    endDrag(event) {
      this.showWarning = true

      const newParentHash = event['targetNode']['id']

      this.$set(event['dragNode'], 'role_parent_hash', newParentHash)
    },
    tpl (...args) {
      let {0: node, 2: parent, 3: index} = args
      let titleClass = node.selected ? 'node-title node-selected' : 'node-title'
      if (node.searched) titleClass += ' node-searched'
      if(parent === null) {
        return <span draggable="true">
          <feather-icon icon="UsersIcon"  class="h-5 w-5 ml-4" />
          <span style="cursor: move!important;" class={titleClass} domPropsInnerHTML={node.title} onClick={() => {
            this.$refs.tree.nodeSelected(node)
          }}></span>
          <feather-icon icon="Edit2Icon"  class="h-4 w-4 cursor-pointer text-primary mr-2" onClick={() => {
            this.$router.push(`/roles/edit/${node.id}`)
          }}/>
        </span>
      } else {
        return <span draggable="true">
          <feather-icon icon="UsersIcon"  class="h-5 w-5 ml-4" />
          <span style="cursor: move!important;" class={titleClass} domPropsInnerHTML={node.title} onClick={() => {
            this.$refs.tree.nodeSelected(node)
          }}></span>
          <feather-icon icon="Edit2Icon"  class="h-4 w-4 cursor-pointer text-primary mr-2" onClick={() => {
            this.$router.push(`/roles/edit/${node.id}`)
          }}/>
          <feather-icon icon="TrashIcon" class="h-4 w-4 cursor-pointer text-danger" onClick={() => {
            this.onRoleDelete(node.id, node.users)
          }}/>
        </span>
      }
    },
    // tpl (...args) {
    //   let {0: node, 2: parent, 3: index} = args
    //   let titleClass = node.selected ? 'node-title node-selected' : 'node-title'
    //   if (node.searched) titleClass += ' node-searched'
    //   return <span draggable="true">
    //      <span style="cursor: move!important;" class={titleClass} domPropsInnerHTML={node.title} onClick={() => {
    //        this.$refs.tree.nodeSelected(node)
    //      }}></span>
    //   <button class="btn-async text-primary border-none cursor-pointer px-2 py-1 mr-2 rounded" onClick={() => this.asyncLoad(node)}><feather-icon icon="Edit2Icon"  class="h-4 w-4 cursor-pointer" /></button>
    //   <button class="btn-delete text-danger border-none cursor-pointer px-2 py-1 rounded" onClick={() => this.$refs.tree.delNode(node, parent, index)}>
    //   <feather-icon icon="TrashIcon"  class="h-4 w-4 cursor-pointer" />
    //   </button>
    //   </span>
    // },
    cancelChanges () {
      this.$vs.loading({type: 'default'})
      this.loadLayout()
    },
    async getParameters () {
      this.$vs.loading({type: 'default'})

      // await fetch(this.$store.state.auth.api_url, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_role_parameters',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'get_application_role_parameters',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token
        }
      })
        .then(async (response) => {
          const roles = []
          await response.json().then(async (responseData) => {
            responseData.parameters.roles.forEach((item) => {
              const role = {
                hash: item.hash,
                name: item.name
              }

              roles.push(role)
            })

            this.roleOptions = roles
          })
        })
        .catch((error) => {
          console.log(error)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('ROLES.OperationNotCompleted'),
            text: this.$t('ROLES.ErrorLoadingParameters'),
            iconPack: 'feather',
            icon: 'icon-icon-alert-circle',
            color: 'danger'
          })
        })
    },
    async loadLayout () {
      this.showBody = false
      // fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_roles',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(`${this.$store.state.auth.api_url}`, {
        command: 'get_application_roles',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token
        }
      })
        .then(async (response) => {
          if (response.status === 200) {

            response.json().then((responseData) => {

              responseData.roles[0].expanded = true

              const roles = responseData.roles[0]

              roles['checked'] = false

              function buildTree (roleObject) {

                Object.defineProperty(roleObject, 'id',
                  Object.getOwnPropertyDescriptor(roleObject, 'role_hash'))
                delete roleObject['role_hash']

                Object.defineProperty(roleObject, 'title',
                  Object.getOwnPropertyDescriptor(roleObject, 'role_name'))
                delete roleObject['role_name']

                Object.defineProperty(roleObject, 'children',
                  Object.getOwnPropertyDescriptor(roleObject, 'role_children'))
                delete roleObject['role_children']

                // delete roleObject['id']
                // delete roleObject['users']
                // delete roleObject['role_parent_hash']

                roleObject['expanded'] = true

                if (roleObject.children.length > 0) {
                  roleObject.children.forEach((item) => {
                    buildTree(item)
                  })
                }
              }

              buildTree(roles)

              this.treeData = [roles]
            })

            this.showBody = true

            this.showWarning = false

            this.$vs.loading.close()

          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: this.$t('ROLES.OperationNotCompleted'),
              text: this.$t('ROLES.OperationNotLoadRoles'),
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('ROLES.OperationNotCompleted'),
            text: this.$t('ROLES.OperationNotLoadRoles'),
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'danger'
          })
          throw new Error(e.message)
        })

      this.chartData = {}
    },
    addNewClicked () {
      this.$router.push('/roles/add')
    },
    save_changes () {
      /* eslint-disable */
      // Here will go your API call for updating data
      // You can get data in "this.data_local"
      /* eslint-enable */
    },
    clickCard (e) {
      if (e.target.tagName === 'svg' || e.target.tagName === 'path' || e.target.tagName === 'polyline' || e.target.tagName === 'line') {
        const element = e.target

        let elementId = null
        let action = ''

        if (element.tagName === 'svg') {
          action = element.getAttribute('data-action')
          elementId = JSON.parse(element.parentElement.parentElement.parentElement.getAttribute('data-source')).id
        } else {
          action = element.parentElement.getAttribute('data-action')
          elementId = JSON.parse(element.parentElement.parentElement.parentElement.parentElement.getAttribute('data-source')).id
        }

        if (action === 'edit') {
          this.onRoleEdit(elementId)
        } else if (action === 'delete') {
          this.onRoleDelete(elementId)
        }
      }
    },
    onRoleEdit (roleHash) {
      this.$router.push(`/roles/edit/${  roleHash}`)
    },
    onRoleDelete (roleHash, users) {

      this.currentRoleToDelete = roleHash

      if (users > 0) {
        this.$vs.dialog({
          color: 'warning',
          title: this.$t('ROLES.Attention'),
          text: this.$t('ROLES.RoleHasUsers'),
          accept: this.acceptMigrateUser,
          acceptText: this.$('ROLES.MigrateAutomatically'),
          buttonCancel: true,
          cancel: this.cancelMigrateUser
        })
      } else {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('ROLES.ConfirmDeleteRole'),
          text: this.$t('ROLES.AreYouSureDeleteRole'),
          acceptText: this.$t('ROLES.YesDelete'),
          cancelText: this.$t('ROLES.NoCancel'),
          accept: this.deleteRole
        })
      }
    },
    acceptMigrateUser () {
      this.roleOptionsFiltered = this.roleOptions.filter(item => item.hash !== this.currentRoleToDelete)

      this.activeMigratePrompt = true
    },
    migrateRoleUsers () {

      this.$vs.loading({type: 'default'})

      fetch(this.$store.state.auth.api_url, {
        method: 'POST', headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          command: 'migrate_role_users',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            role_hash: this.currentRoleToDelete,
            role_hash_to_migrate: this.roleToMigrate.hash
          }
        })
      })
        .then(async (response) => {
          if (response.status === 200) {

            this.$vs.loading.close()
            this.$vs.notify({
              title: this.$t('ROLES.OperationCompleted'),
              text: this.$t('ROLES.UsersMigratedSuccessfully'),
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })

            this.deleteRole()

            // this.$vs.loading({type: 'default'})
            // document.querySelector('div.orgchart').remove()
            // document.querySelector('.drag-chart').innerHTML = ""
            // this.loadLayout()
          } else if (response.status === 401) {
            this.$vs.loading.close()
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: this.$t('ROLES.OperationNotCompleted'),
              text: this.$t('ROLES.ErrorMigratingRoleUsers'),
              iconPack: 'feather',
              icon: 'icon-icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((error) => {
          console.log(error)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('ROLES.OperationNotCompleted'),
            text: this.$t('ROLES.ErrorLoadingParameters'),
            iconPack: 'feather',
            icon: 'icon-icon-alert-circle',
            color: 'danger'
          })
        })
    },
    deleteRole () {

      this.$vs.loading({type: 'default'})

      fetch(this.$store.state.auth.api_url, {
        method: 'POST', headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          command: 'delete_application_role',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            role_hash: this.currentRoleToDelete
          }
        })
      })
        .then(async (response) => {
          if (response.status === 200) {

            this.activeMigratePrompt = false
            this.currentRoleToDelete = ''
            this.roleToMigrate = null

            this.$vs.loading.close()
            this.$vs.notify({
              title: this.$t('ROLES.OperationCompleted'),
              text: this.$t('ROLES.RoleDeletedSuccessfully'),
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })

            await this.getParameters()

            this.$vs.loading({type: 'default'})
            this.loadLayout()
          } else if (response.status === 401) {
            this.$vs.loading.close()
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else if (response.status === 400) {
            this.$vs.loading.close()
            response.json().then(response => {
              if (response.message === 'Role Has Children') {
                this.$vs.notify({
                  title: 'Atenção!',
                  text: 'Este cargo possui cargos subordinados. Reorganize a estrutura antes de excluir',
                  iconPack: 'feather',
                  icon: 'icon-icon-alert-circle',
                  color: 'warning'
                })
              } else if (response.message === 'Role Has Users') {
                this.$vs.loading.close()
                this.$vs.dialog({
                  color: 'warning',
                  title: 'Atenção!',
                  text: 'Este cargo ainda possui usuários associados. \n       Ao clicar em Migrar Automaticamente, você poderá migrar todos os usuários de forma automática para outro cargo. Caso prefira migrar os usuários de forma manual, basta fechar este aviso.',
                  accept: this.acceptMigrateUser,
                  acceptText: 'Migrar Automaticamente',
                  buttonCancel: true,
                  cancel: this.cancelMigrateUser
                })
              }
            })
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: this.$t('ROLES.OperationNotCompleted'),
              text: 'Ocorreu um erro ao migrar os usuários do cargo!',
              iconPack: 'feather',
              icon: 'icon-icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((error) => {
          console.log(error)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('ROLES.OperationNotCompleted'),
            text: this.$t('ROLES.ErrorLoadingParameters'),
            iconPack: 'feather',
            icon: 'icon-icon-alert-circle',
            color: 'danger'
          })
        })

    },
    cancelMigrateUser () {

    },
    closeMigratePrompt () {

    },
    async updateLayout () {

      this.$vs.loading({type: 'default'})

      const roles = JSON.parse(JSON.stringify(this.treeData))

      function buildTree (roleObject) {

        Object.defineProperty(roleObject, 'role_hash',
          Object.getOwnPropertyDescriptor(roleObject, 'id'))
        delete roleObject['id']

        Object.defineProperty(roleObject, 'role_name',
          Object.getOwnPropertyDescriptor(roleObject, 'title'))
        delete roleObject['title']

        Object.defineProperty(roleObject, 'role_children',
          Object.getOwnPropertyDescriptor(roleObject, 'children'))
        delete roleObject['children']

        delete roleObject['expanded']
        delete roleObject['checked']
        delete roleObject['users']

        if (roleObject.role_children.length > 0) {
          roleObject.role_children.forEach((item) => {
            buildTree(item)
          })
        }
      }

      buildTree(roles[0])

      // fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'update_roles_hierarchy',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       roles_hierarchy: roles
      //     }
      //   })
      // })
      await performFetch(`${this.$store.state.auth.api_url}`, {
        command: 'update_roles_hierarchy',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          roles_hierarchy: roles
        }
      })
        .then((response) => {
          if (response.status === 200) {

            this.$vs.loading.close()

            this.showWarning = false

            this.$vs.notify({
              title: this.$t('ROLES.OperationCompleted'),
              text: this.$t('ROLES.HierarchyUpdatedSuccessfully'),
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.notify({
              title: this.$t('ROLES.HierarchyUpdatedSuccessfully'),
              text: this.$t('ROLES.ErrorUpdatingHierarchy'),
              iconPack: 'feather',
              icon: 'icon-info',
              color: 'danger'
            })
          }
          this.$vs.loading.close()
        })
        .catch(err => {
          this.$vs.notify({
            title: this.$t('ROLES.OperationNotCompleted'),
            text: this.$t('ROLES.ErrorUpdatingHierarchy'),
            iconPack: 'feather',
            icon: 'icon-info',
            color: 'danger'
          })
          this.$vs.loading.close()
        })

    },
    dropCriteria () {

      this.showWarning = true

      return true
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/tree.scss";
</style>
